<template>
    <div name="sign-up" class="sign-up">
        <agreement 
            v-show="step === 0"
            @next="next"
            @resetCount="resetTimeoutCount"
        />
        <input-phone 
            v-show="step === 1"
            @back="back"
            @complete="complete"
            @resetCount="resetTimeoutCount"
        />
        <complete 
            v-show="step === 2"
            @goHome="goHome"
            @resetCount="resetTimeoutCount"
        />
    </div>
</template>

<script>
import Agreement from '@/components/showcase/Agreement';
import InputPhone from '@/components/showcase/InputPhone';
import Complete from '@/components/showcase/Complete';
// 0. 휴대전화번호
// 1. 약관페이지
export default {
  components: { Agreement, InputPhone, Complete },
    name: 'signUp',
    data: function()
    {
        return {
            step: 0
        }
    },
    computed: {
        basePath: function() {
            return '/' + this.$route.params.showcase
        }
    },
    mounted: function()
    {
        //진입시 home으로 이동 카운트
        this.resetTimeoutCount();
    },
    methods: {
        resetTimeoutCount: function () {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(this.goHome, 50000);
        },
        goHome: function() {
            this.clearTimer();
            window.location.href  = this.basePath + '/home'
        },
        clearTimer: function()
        {
            clearTimeout(this.timeoutId);
            this.timerId = null;
        },
        next: function(step)
        {
            this.resetTimeoutCount();
            this.step = step
        },
        back: function()
        {
            this.resetTimeoutCount();
            this.step = 0
        },
        complete: function()
        {
            this.resetTimeoutCount();
            this.step = 2;
        }
    }
   
}
</script>

<style scoped>
    .sign-up {
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }
    
</style>


// WEBPACK FOOTER //
// src/page/showcase/SignUp.vue